module.exports = __webpack_public_path__ + "static/img/banner.6b3395f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_atp/banner.jpg
// module id = CFoX
// module chunks = 0